import { useState } from 'react';

import type { CreateSupplierContact } from '@dcc-erp/shared';

import {
  useSupplierContacts,
  useUpsertContact,
  useDeleteContact,
} from '../../lib/queries/suppliers';

// Contacts sub-table (chasing original documents). RECONCILED with Plan A's real
// shared type: the draft is a `CreateSupplierContact` (omits id/supplierId); the
// plan body's `SupplierContactDto` does not exist in `@dcc-erp/shared`.
export function ContactsSubTable({
  companyId,
  supplierId,
}: {
  companyId: string | undefined;
  supplierId: string;
}) {
  const { data: contacts = [], isLoading } = useSupplierContacts(companyId, supplierId);
  const upsert = useUpsertContact(companyId, supplierId);
  const del = useDeleteContact(companyId, supplierId);
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState<CreateSupplierContact>({ name: '', isPrimary: false });

  async function save() {
    if (!draft.name.trim()) return;
    await upsert.mutateAsync(draft);
    setDraft({ name: '', isPrimary: false });
    setAdding(false);
  }

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      <table className="tbl" style={{ width: '100%', fontSize: 13 }}>
        <thead>
          <tr>
            <th>ชื่อ</th>
            <th>ตำแหน่ง</th>
            <th>อีเมล</th>
            <th>โทร</th>
            <th>หลัก</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={6} className="muted">
                กำลังโหลด…
              </td>
            </tr>
          ) : contacts.length === 0 && !adding ? (
            <tr>
              <td colSpan={6} className="muted">
                — ยังไม่มีผู้ติดต่อ —
              </td>
            </tr>
          ) : (
            contacts.map((c) => (
              <tr key={c.id}>
                <td>{c.name}</td>
                <td>{c.role ?? '—'}</td>
                <td>{c.email ?? '—'}</td>
                <td>{c.phone ?? '—'}</td>
                <td>{c.isPrimary ? <span className="badge positive">หลัก</span> : '—'}</td>
                <td>
                  <button
                    type="button"
                    className="btn sm ghost"
                    onClick={() => void del.mutateAsync(c.id)}
                  >
                    ลบ
                  </button>
                </td>
              </tr>
            ))
          )}
          {adding && (
            <tr>
              <td>
                <input
                  className="input"
                  placeholder="ชื่อผู้ติดต่อ"
                  value={draft.name}
                  onChange={(e) => setDraft({ ...draft, name: e.target.value })}
                />
              </td>
              <td>
                <input
                  className="input"
                  value={draft.role ?? ''}
                  onChange={(e) => setDraft({ ...draft, role: e.target.value })}
                />
              </td>
              <td>
                <input
                  className="input"
                  value={draft.email ?? ''}
                  onChange={(e) => setDraft({ ...draft, email: e.target.value })}
                />
              </td>
              <td>
                <input
                  className="input"
                  value={draft.phone ?? ''}
                  onChange={(e) => setDraft({ ...draft, phone: e.target.value })}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={draft.isPrimary}
                  onChange={(e) => setDraft({ ...draft, isPrimary: e.target.checked })}
                />
              </td>
              <td>
                <button
                  type="button"
                  className="btn sm primary"
                  disabled={upsert.isPending}
                  onClick={() => void save()}
                >
                  บันทึก
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {!adding && (
        <button type="button" className="btn sm ghost" onClick={() => setAdding(true)}>
          ＋ เพิ่มผู้ติดต่อ
        </button>
      )}
    </div>
  );
}
